import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'

import s from './Ssixth.module.scss'

class Ssixth extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      // 初始state
      index: 0,
      opacity: 1,
      showAnimation: false
    }
    this._handleScroll = this.handleScroll.bind(this)
  }
  componentDidMount() {
    window.addEventListener('scroll', this._handleScroll)
    // 初始检查一次位置
    this._handleScroll()
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this._handleScroll)
  }
  handleScroll() {
    const clientHeight = document.documentElement.clientHeight
    const ssixthRect = this.refs.Ssixth.getBoundingClientRect()
    
    // 当元素的顶部进入视口60%时触发动画
    if (ssixthRect.top < clientHeight * 0.6 && !this.state.showAnimation) {
      this.setState({ showAnimation: true })
    }
  }
  render() {
    const { locale } = this.props
    const { showAnimation } = this.state
    
    return (
      <div ref="Ssixth">
        <div className={s.Ssixth} id="topnote-1">
          <div className={s.wrap}>
            <div className={s.text} ref="text">
              <div
                className={`
                  ${locale.indexOf('US') > -1 
                    ? s.mi_en
                    : s.mi}
                  ${showAnimation ? s.animateIn : s.hidden}
                `}
              ></div>
              <div className={`${s.title} ${showAnimation ? s.animateIn : s.hidden}`}>
                <FormattedMessage id="dk3_five_title" values={{ br: <br /> }} />
                <sup className={s.footnote}>
                  <a href="#footnote-2" aria-label="脚注2">
                    2
                  </a>
                </sup>
              </div>
              <div className={`${s.desc} ${showAnimation ? s.animateIn : s.hidden}`}>
                <FormattedMessage id="dk3_five_desc" values={{ br: <br /> }} />
           
              </div>
              
              <div className={s.pic}>
                <div className={s.left}>
                  <div className={s.left_title}>
                    <FormattedMessage id="dk3_five_left_title" values={{br: <br/>}}/>
               
                  </div>
                  <div className={s.left_icons}>
                    <div className={s.item1}>
                      <div className={s.item1_icon}></div>
                      <div className={s.item1_desc}>
                        <FormattedMessage id="dk3_five_left_item1" values={{br: ' '}}/>
                      </div>
                    </div>
                    <div className={s.plus}></div>
                    <div className={s.item2}>
                      <div className={s.item2_icon}></div>
                      <div className={s.item2_desc}>
                        <FormattedMessage id="dk3_five_left_item2" />
                      </div>
                    </div>
                    <div className={s.plus}></div>
                    <div className={s.item3}>
                      <div className={s.item3_icon}></div>
                      <div className={s.item3_desc}>
                        <FormattedMessage id="dk3_five_left_item3" />
                        
                      </div>
                    </div>
                  </div>
                </div>

                <div className={s.right}>
                  <div className={s.left_title}>
                    <FormattedMessage id="dk3_five_right_title" values={{br: <br/>}}/>

               
                  </div>
                  <div className={s.right_icons}>
                    <div className={s.item1}>
                      <div className={s.item1_icon}></div>
                      <div className={s.item1_desc}>
                        <FormattedMessage id="dk3_five_left_item1" values={{br: ' '}}/>
                      </div>
                    </div>
                    <div className={s.plus}></div>
                    <div className={s.item2}>
                      <div className={s.item2_icon}></div>
                      <div className={s.item2_desc}>
                        <FormattedMessage id="dk3_five_left_item2" />
                      </div>
                    </div>
                    <div className={s.plus}></div>
                    <div className={s.item3}>
                      <div className={s.item4_icon}></div>
                      <div className={s.item3_desc}>
                        <FormattedMessage id="dk3_five_right_item4" />
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  locale: state.language,
})

const SSixth = connect(mapStateToProps)(Ssixth)

export default SSixth
